import Selector from 'components/Selector'

const EmailIntentModelTypeSelector = ({
  emailIntentModelType,
  setEmailIntentModelType,
  models,
  isDarkBackdrop,
}: {
  emailIntentModelType: string
  setEmailIntentModelType: (emailIntentModelType: string) => void
  models: string[]
  isDarkBackdrop: boolean // used to conditionally style label text color, sometimes this component is on a light / dark backdrop
}) => {
  return (
    <Selector
      id="email-intent-model-type-selector"
      label="Email intent model type"
      option={emailIntentModelType}
      options={models}
      setOption={setEmailIntentModelType}
      isDarkBackdrop={isDarkBackdrop}
      width="240px"
    />
  )
}

export default EmailIntentModelTypeSelector
